import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ApiClient from '../../Services/ApiClient';
import { useAlert } from '../ui/alertProvider';
import AuthContext from '../../store/authContext';

const ApproveUser: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('code') || searchParams.get('token');
  const email = searchParams.get('email');
  const [details, setDetails] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [denying, setDenying] = useState(false);
  const [denyReason, setDenyReason] = useState('');
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const auth = useContext(AuthContext) as any;

    useEffect(() => {
        if (!token) {
            console.log('approveuser useeffect token is null');
            return;
        }
        // if not logged in or not superadmin, redirect to login and include returnUrl so user returns here after login
        if (!auth?.isLoggedIn || !auth?.isSuperAdmin) {
            console.log('ot logged in or not superadmin, redirect to login and include returnUrl so user returns here after login');

            const target = `/approve-user?token=${encodeURIComponent(token)}${email ? `&email=${encodeURIComponent(email)}` : ''}`;
            navigate(`/login?returnUrl=${encodeURIComponent(target)}`);
            return;
        }

        const load = async () => {
            try {
                console.log('approveuser.tsx load');
                // ensure user is authenticated and has SuperAdmin role on client side (AuthContext will redirect if not logged in)
                const res = await ApiClient.get(`/api/admin/approval/${token}`);
                setDetails(res);
            } catch (e) {
                showAlert('לא ניתן לטעון את פרטי הבקשה', 'error');
            }
        };
        load();
    }, [token]);

  const handleConfirm = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await ApiClient.post(`/api/admin/approval/${token}/confirm`, {});
      showAlert('המשתמש נוצר בהצלחה', 'success');
      navigate('/users');
    } catch (e: any) {
      const server = e?.data;
      const msg = (server && (server?.errors || server?.message || server?.failureReason)) || e?.message || 'אישור נכשל';
      // If server returned structured errors, prefer a human-friendly message
      if (server && server.errors && server.errors.email) showAlert(server.errors.email, 'error');
      else showAlert(msg, 'error');
    } finally { setLoading(false); }
  };

  const handleDeny = async () => {
    if (!token) return;
    setDenying(true);
    try {
      const res = await ApiClient.post(`/api/admin/approval/${token}/deny`, { reason: denyReason });
      showAlert('הבקשה נדחתה', 'success');
      navigate('/users');
    } catch (e: any) {
      const msg = e?.data || 'דחייה נכשלה';
      showAlert(msg, 'error');
    } finally { setDenying(false); }
  };

  if (!token) return <div className="page-padding">אסימון לא נמצא</div>;

  return (
    <div className="page-padding">
      <h2>אישור משתמש חדש</h2>
      {details ? (
        <div>
          <div><strong>שם:</strong> <span id="approve-name">{details.name || details.Name}</span></div>
          <div><strong>אימייל:</strong> <span id="approve-email">{details.email || details.Email}</span></div>
          <div><strong>תפקיד:</strong> <span id="approve-role">{details.userRole || details.UserRole}</span></div>
          <div><strong>טלפון:</strong> <span id="approve-phone">{details.userPhone || details.UserPhone}</span></div>
          <div className="mt-12 flex gap-8">
            <button className="btn btn-primary" onClick={handleConfirm} disabled={loading} aria-label="אשר והוסף משתמש">{loading ? 'מעבד...' : 'אשר והוסף משתמש'}</button>
            <div style={{ flex: 1 }}>
              <label htmlFor="denyReason" className="sr-only">סיבת דחייה (אופציונלי)</label>
              <textarea id="denyReason" placeholder='סיבת דחייה (אופציונלי)' value={denyReason} onChange={e => setDenyReason(e.target.value)} className="form-textarea" aria-describedby="approve-email" />
              <div className="mt-8">
                <button className="btn" onClick={handleDeny} disabled={denying} aria-label="דחה בקשה">{denying ? 'מעבד...' : 'דחה בקשה'}</button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>טוען...</div>
      )}
    </div>
  );
};

export default ApproveUser;
